import BareTracking from './bare-tracking.js';

// Load BareTracking
(() => {
  const tracker = new BareTracking();
  const _bm = function() {
    let args = [].slice.call(arguments);
    tracker[args.shift()].apply(tracker, args);
  }

  const trackingMethod = window['baretracking-method'];
  // Copy over any bm calls from before pageload
  const queuedArgs = window[trackingMethod].q;
  // Run all queued tracking commands
  queuedArgs.forEach(args => _bm.apply(null, args));

  // Replace the fake tracking method for future calls
  window[trackingMethod] = _bm;
})();
